import { render, staticRenderFns } from "./UploadPic.vue?vue&type=template&id=9b20a256&scoped=true&"
import script from "./UploadPic.vue?vue&type=script&lang=js&"
export * from "./UploadPic.vue?vue&type=script&lang=js&"
import style0 from "./UploadPic.vue?vue&type=style&index=0&id=9b20a256&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b20a256",
  null
  
)

export default component.exports